import React, { useState, useEffect } from "react";
import { Box, Container, Link, Typography } from "@mui/material";
import VersionService from "../../services/versionService";

export const Footer = () => {
  const versionService = VersionService();
  const [version, setVersion] = useState("1.0");

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const v = await versionService.getVersion();
        if (v) setVersion(v);
      } catch (_) {}
    };
    fetchVersion();
  }, []);

  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 2,
        borderTop: (t) => `1px solid ${t.palette.divider}`,
        backgroundColor: "background.default",
      }}
    >
      <Container maxWidth="xl">
        <Typography
          variant="caption"
          color="text.secondary"
          align="center"
          sx={{ display: "block" }}
        >
          Made by{" "}
          <Link
            href="mailto:victor.zaragoza@kovimatic.com"
            color="primary"
            underline="hover"
            sx={{ fontWeight: 600 }}
          >
            Kovimatic
          </Link>{" "}
          · 2023-2025 · v. 2.0/{version}
        </Typography>
      </Container>
    </Box>
  );
};
